import styled from 'styled-components'
import { Button } from '../../../../shared/components'

export const CenteredButton = styled(Button)`
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 150px;
`
